import { CarouselLeftArrowIcon, CarouselRightArrowIcon, NavCloseIcon } from 'assets/icons';
import CustomCarousel from 'components/custom-carousel/CustomCarousel';
import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import { AttachmentFile, VoidFn } from 'types/baseTypes';

interface ImagePreviewProps {
  className?: string;
  images: AttachmentFile[];
  selectedIndex: number;
  onClose: VoidFn;
}

const ImagePreview: FC<ImagePreviewProps> = ({ images, onClose, selectedIndex }) => {
  return ReactDOM.createPortal(
    // 'root' is added as an id inorder to access tailwind css from react portals
    <div id="root">
      <div
        className={
          'customTransparentScroll fixed inset-0 z-[999] flex min-h-screen items-center justify-center bg-[#001324CC]'
        }>
        <NavCloseIcon
          className="line-stroke-current line absolute top-9 right-9 cursor-pointer text-primary"
          onClick={onClose}
        />
        <div className="mx-auto w-full max-w-screen-lg ">
          <CustomCarousel
            autoPlay={false}
            centerSlidePercentage={100}
            showIndicator={false}
            nextIconStyles="top-1/2 transform -translate-y-1/2 right-0"
            prevIconStyles="top-1/2 transform -translate-y-1/2 left-0"
            selectedIndex={selectedIndex}
            NextIcon={CarouselRightArrowIcon}
            PrevIcon={CarouselLeftArrowIcon}>
            {images.map((item, index) => (
              <div key={item.url + index}>
                <div className="relative h-0" style={{ paddingBottom: '56.25%' }} key={item.title + index}>
                  <img src={item.urlLink} alt="placeholder" className="absolute inset-0 h-full w-full object-contain" />
                </div>
                <div className="mt-6 text-17px font-bold text-secondaryBtn">{item.title}</div>
              </div>
            ))}
          </CustomCarousel>
        </div>
      </div>
    </div>,
    document.getElementById('portal-root')
  );
};

export default ImagePreview;
